'use strict';
moduleConfig.registerModule('eclipseApp.onboarding', ['eclipseApp.core', 'ute.sms.recovery.fido', 'eclipseApp.myAccount']);
